/** * InviteProductionLine * */

<template>
  <div class="invite-production-line">
    <div class="invite-production-title">
      <span>Choose Production Lines</span>
    </div>
    <div class="invite-production-row">
      <div class="wt-checkbox">
        <div class="checkbox-box"></div>
        <label>
          <input type="checkbox" v-model="isAllChecked" @change="selectAll" />
          <span>Select all</span>
        </label>
      </div>
      <div v-if="!hasManyOrganizations" class="programmers">
        <div
          v-for="programmer in programmers"
          :key="programmer.id"
          class="wt-checkbox"
        >
          <div class="checkbox-box"></div>
          <label>
            <input
              type="checkbox"
              :value="programmer.id"
              v-model="checkedIds"
              @change="select"
            />
            <span>{{ programmer.label }}</span>
          </label>
        </div>
      </div>
      <div v-if="hasManyOrganizations" class="organizations">
        <div
          v-for="org in organizations"
          :key="org.organizationId"
          class="organization"
        >
          <div class="org-title">
            <span class="name">{{ org.organizationName }}</span>
          </div>
          <div class="programmers">
            <div
              v-for="programmer in org.programmers"
              :key="programmer.programmerId"
              class="wt-checkbox programmer"
            >
              <div class="checkbox-box"></div>
              <label>
                <input
                  type="checkbox"
                  :value="programmer.programmerId"
                  v-model="checkedIds"
                  @change="select"
                />
                <span>{{ programmer.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Analytics from 'c/WtAnalytics';

export default {
  props: {
    handlers: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      checkedIds: [],
      isAllChecked: true,
    };
  },

  mounted: function () {
    this.checkedIds = this.programmersIds;

    this.onProductionLineChange();

    this.$watch('checkedIds', this.onProductionLineChange);
  },

  computed: {
    organizations() {
      return [...this.handlers.getOrganizations()].map((org) => ({
        ...org,
        programmers: [...org.programmers].sort(function (a, b) {
          // sort label case insensitive
          return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
        }),
      }));
    },
    programmers: function () {
      return this.hasManyOrganizations
        ? [...this.organizations]
            .map(({ programmers }) =>
              [...programmers].map((programmer) => ({
                id: programmer.programmerId,
                label: programmer.label,
              }))
            )
            .reduce((a, sub) => [...a, ...sub], [])
        : this.handlers.getProgrammers().sort(function (a, b) {
            // sort label case insensitive
            return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
          });
    },

    programmersIds: function () {
      return this.programmers.map((programmer) => programmer.id);
    },
    hasManyOrganizations() {
      return !!this.organizations.length;
    },
  },

  methods: {
    select: function () {
      this.isAllChecked = this.checkedIds.length === this.programmersIds.length;
    },

    selectAll: function () {
      if (this.isAllChecked) {
        this.checkedIds = this.programmersIds;
      } else {
        this.checkedIds = [];
      }
    },

    onProductionLineChange: function (checkedIds) {
      if (this.handlers.onChangeData) {
        this.handlers.onChangeData('productionLine', this.checkedIds);
      }

      // if checkedIds has changed, then send analytics
      if (checkedIds) {
        Analytics.trigger('analytics:invitations:productionLineChanged');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-production-line {
  .invite-production-title {
    width: 100%;
    display: flex;
    > span:empty {
      flex: 1 1 auto;
    }
  }

  .organizations {
    .organization {
      margin: 0.5em 0;
    }
    .org-title {
      margin-bottom: 1em;
      .name {
        font-weight: bold;
      }
    }
  }
}
</style>
